"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventFilters = void 0;
exports.putDataToEventsCacheTable = putDataToEventsCacheTable;
exports.isTimeRange = isTimeRange;
exports.isEventTypes = isEventTypes;
exports.isAnd = isAnd;
exports.queryFromEventsCacheTable = queryFromEventsCacheTable;
exports.convertEventNodeFieldsToBigInt = convertEventNodeFieldsToBigInt;
exports.parseDynamoDBAttributesForEvents = parseDynamoDBAttributesForEvents;
exports.getLastUpdatedTimeFromEventsCacheTable = getLastUpdatedTimeFromEventsCacheTable;
exports.updateEventsCacheTable = updateEventsCacheTable;
const tslib_1 = require("tslib");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const lib_dynamodb_1 = require("@aws-sdk/lib-dynamodb");
const dotenv = tslib_1.__importStar(require("dotenv"));
dotenv.config();
async function putDataToEventsCacheTable(events) {
    const tableName = process.env.EVENTS_CACHE_TABLE_NAME;
    const ddbClient = process.env.LOCAL_AWS
        ? new client_dynamodb_1.DynamoDBClient({ region: "local", endpoint: "http://localhost:8000" })
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    if (!tableName) {
        throw new Error("Table name not found from env");
    }
    try {
        const promises = events.map(async (event) => {
            const thirtyOneDaysInSeconds = 31 * 24 * 60 * 60;
            const ttlInSeconds = Math.floor(Date.now() / 1000) + thirtyOneDaysInSeconds;
            const item = {
                "timestamp#digest#seq": `${event.timestamp}#${event.txDigest}#${event.eventSeq
                    .toString()
                    .padStart(3, "0")}`,
                ...event,
                type: event.type,
                expiresAt: ttlInSeconds,
            };
            const command = new lib_dynamodb_1.PutCommand({
                TableName: tableName,
                Item: item,
            });
            await ddbDocClient.send(command);
        });
        await Promise.all(promises);
    }
    catch (error) {
        console.error("Error writing data to DynamoDB:", error);
    }
}
exports.eventFilters = ["eventTypes", "timeRange", "and"];
function isTimeRange(filter) {
    return filter.timeRange !== undefined;
}
function isEventTypes(filter) {
    return filter.eventTypes !== undefined;
}
function isAnd(filter) {
    return filter.and !== undefined;
}
async function queryFromEventsCacheTable(filter) {
    const tableName = process.env.EVENTS_CACHE_TABLE_NAME;
    const ddbClient = process.env.LOCAL_AWS
        ? new client_dynamodb_1.DynamoDBClient({ region: "local", endpoint: "http://localhost:8000" })
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    if (!tableName) {
        throw new Error("Table name not found from env");
    }
    let commandInputs = [];
    if (isAnd(filter)) {
        const filters = filter.and;
        let eventTypes = [];
        let timeRange = undefined;
        for (const filter of filters) {
            if (isTimeRange(filter)) {
                timeRange = filter.timeRange;
            }
            else if (isEventTypes(filter)) {
                eventTypes = [...eventTypes, ...filter.eventTypes];
            }
            else {
                console.warn(`skipping unexpected filter: `, filter);
            }
        }
        commandInputs = eventTypes.map((eventType) => {
            const input = {
                TableName: tableName,
                KeyConditionExpression: "#type = :type AND #time BETWEEN :start AND :end",
                ExpressionAttributeNames: {
                    "#time": "timestamp#digest#seq",
                    "#type": "type",
                },
                ExpressionAttributeValues: {
                    ":type": { S: eventType },
                    ":start": { S: `${timeRange.startTime.toString()}#` },
                    ":end": { S: `${timeRange.endTime.toString()}#~~~~~~` },
                },
            };
            return input;
        });
    }
    else if (isTimeRange(filter)) {
        console.log("This timeRange Type filter is not yet implemented");
        // todo --> fetch all the events between these times
    }
    else if (isEventTypes(filter)) {
        console.log("This event Type filter is not yet implemented");
        // todo --> fetch all the events of the given types
    }
    else {
        console.warn("event filter did not match, returning empty array");
        return [];
    }
    try {
        const events = await Promise.all(commandInputs.map((input) => executeQueryWithPagination(input, ddbDocClient)));
        return events.flat();
    }
    catch (error) {
        console.error("Error fetching items");
        throw error;
    }
}
async function executeQueryWithPagination(command, ddbDocClient) {
    let items = [];
    let lastEvaluatedKey;
    do {
        const response = await ddbDocClient.send(new client_dynamodb_1.QueryCommand({ ...command, ExclusiveStartKey: lastEvaluatedKey }));
        if (response.Items) {
            const parsedItems = response.Items.map((item) => {
                return Object.fromEntries(Object.entries(item).map((entry) => [
                    entry[0],
                    parseDynamoDBAttributesForEvents(entry[1]),
                ]));
            });
            items = items.concat(parsedItems);
        }
        lastEvaluatedKey = response.LastEvaluatedKey;
    } while (lastEvaluatedKey);
    return items;
}
function convertEventNodeFieldsToBigInt(obj) {
    const result = {};
    for (const key in obj) {
        const value = obj[key];
        if (typeof value === "string" && /^[+-]?\d+$/.test(value)) {
            try {
                result[key] = BigInt(value);
            }
            catch {
                result[key] = value;
            }
        }
        else {
            result[key] = value;
        }
    }
    return result;
}
function parseDynamoDBAttributesForEvents(attr) {
    if ("S" in attr)
        return attr.S;
    if ("N" in attr)
        return BigInt(attr.N);
    return undefined;
}
async function getLastUpdatedTimeFromEventsCacheTable() {
    const tableName = process.env.EVENTS_CACHE_TABLE_NAME;
    const ddbClient = process.env.LOCAL_AWS
        ? new client_dynamodb_1.DynamoDBClient({ region: "local", endpoint: "http://localhost:8000" })
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    if (!tableName) {
        throw new Error("Table name not found from env");
    }
    try {
        const params = {
            TableName: tableName,
            KeyConditionExpression: "#type = :type",
            ExpressionAttributeNames: {
                "#type": "type",
            },
            ExpressionAttributeValues: {
                ":type": { S: alphafi_sdk_1.poolInfo["ALPHA"].liquidityChangeEventType },
            },
            ScanIndexForward: false,
            Limit: 1,
        };
        const response = await ddbDocClient.send(new client_dynamodb_1.QueryCommand(params));
        const items = response.Items;
        if (items && items.length > 0) {
            const lastEvent = Object.fromEntries(Object.entries(items[0]).map((entry) => [
                entry[0],
                parseDynamoDBAttributesForEvents(entry[1]),
            ]));
            return Number(lastEvent.timestamp);
        }
        else {
            // TODO --> should consider querying for other types if this fails, return 0 if table is empty
            return 0;
        }
    }
    catch (e) {
        console.error("failed to get last updated time");
        throw e;
    }
}
async function updateEventsCacheTable() {
    try {
        console.time("updateEventsCacheTable");
        const lastUpdatedTime = await getLastUpdatedTimeFromEventsCacheTable();
        console.log("last updated time", lastUpdatedTime);
        const now = Date.now();
        const events = await (0, alphafi_sdk_1.fetchMultiCategoryEvents)({
            eventCategories: alphafi_sdk_1.eventCategories,
            startTime: lastUpdatedTime,
            endTime: now,
            order: "descending",
        });
        const combinedEvents = Object.values(events)
            .flat()
            .map((event) => convertEventNodeFieldsToBigInt(event));
        console.log("events fetched", combinedEvents.length);
        await putDataToEventsCacheTable(combinedEvents);
        console.log("data put to table");
        console.timeEnd("updateEventsCacheTable");
    }
    catch (err) {
        console.error("failed to update table");
        throw err;
    }
}
//# sourceMappingURL=eventsCache.js.map